import * as C from '@/consts'
import component from '@/libs/component'

import Stations from './Stations'
import Period from './Period'
import Car from './Car'
import Options from './Options'
import Remarks from './Remarks'
import Payment from './Payment'
import Confirm from './Confirm'
import Completed from './Completed'
import Cancel from './Cancel'
import Extension from './Extension'

export default [
  {
    path: 'book/new',
    name: 'book/new',
    ...component(Stations),
    meta: {
      type: C.PAGE_USER
    }
  },
  {
    path: 'book/cancel',
    name: 'book/cancel',
    ...component(Cancel),
    meta: {
      type: C.PAGE_USER
    }
  },
  {
    path: 'stations/:stid/book',
    name: 'book',
    redirect: { name: 'book/period' }
  },
  {
    path: 'stations/:stid/book/period',
    name: 'book/period',
    ...component(Period),
    meta: {
      type: C.PAGE_BOOKING
    }
  },
  {
    path: 'stations/:stid/book/car',
    name: 'book/car',
    ...component(Car),
    meta: {
      type: C.PAGE_BOOKING
    }
  },
  {
    path: 'stations/:stid/book/options',
    name: 'book/options',
    ...component(Options),
    meta: {
      type: C.PAGE_BOOKING
    }
  },
  {
    path: 'stations/:stid/book/remarks',
    name: 'book/remarks',
    ...component(Remarks),
    meta: {
      type: C.PAGE_BOOKING
    }
  },
  {
    path: 'stations/:stid/book/payment',
    name: 'book/payment',
    ...component(Payment),
    meta: {
      type: C.PAGE_SUBMIT
    }
  },
  {
    path: 'stations/:stid/book/confirm',
    name: 'book/confirm',
    ...component(Confirm),
    meta: {
      type: C.PAGE_SUBMIT
    }
  },
  {
    path: 'stations/:stid/book/completed',
    name: 'book/completed',
    ...component(Completed),
    meta: {
      type: C.PAGE_SUBMIT
    }
  },
  {
    path: 'book/extension',
    name: 'book/extension',
    ...component(Extension),
    meta: {
      type: C.PAGE_SUBMIT
    }
  }
]
